import type { AdminAiScanFindingProps } from "../../models/admin-ai-scans.models";
import { adminAiScansStyles } from "../../styles/admin-ai-scans.styles";
import AdminAiScanFindingDetails from "./AdminAiScanFindingDetails";
import AdminAiScanFindingSummary from "./AdminAiScanFindingSummary";
import { useState } from "react";

// Keep module findings as compact report rows, with the full explanation available on expansion.
const AdminAiScanFinding = ({ finding, findingFields, expanded, source }: AdminAiScanFindingProps) => {
  const [open, setOpen] = useState(expanded);

  return (
    <details
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
      className={adminAiScansStyles.findingSurface}
      data-test="admin-ai-scan-finding"
    >
      <summary className="cursor-pointer list-none rounded-lg hover:bg-slate-100 focus-visible:outline-green dark:hover:bg-gray-700/50 [&::-webkit-details-marker]:hidden">
        <AdminAiScanFindingSummary finding={finding} source={source} />
        <span className="block px-3 pb-2 text-right text-[11px] font-semibold text-green dark:text-emerald-300">
          {open ? "Hide details" : "View details"}
        </span>
      </summary>
      {open && (
        <div className="border-t border-slate-200 bg-white dark:border-gray-600 dark:bg-gray-800">
          <AdminAiScanFindingDetails finding={finding} findingFields={findingFields} source={source} />
        </div>
      )}
    </details>
  );
};

export default AdminAiScanFinding;
